<template>
  <div>
    <!-- <MessageAlert v-if="isNewMessage"></MessageAlert> -->
    <div class="iv-breadcrumb-container iv-overflow-h iv-main-width">
      <!-- <img class="iv-breadcrumb-container-bg" :src="loadImg('bread-bg.png')" alt=""> -->
      <Iconfont class="iv-fc-45 iv-fs-16 iv-symbol-pt16 iv-symbol-pb16" type="gongzuolianxidian"></Iconfont> <span class="iv-fc-45 iv-fs-16 iv-symbol-pt16 iv-symbol-pb16">当前位置： </span> 
      <Breadcrumb :separator="separator" class="iv-fs-14 iv-symbol-pt16 iv-symbol-pb16 iv-fc-45">
        <span
          class="uit-breadcrumb-item"
          :key="item.id"
          v-for="(item, index) in crumbsList"
          :class="{'iv-fs-20': index === crumbsList.length - 1}">
          <BreadcrumbItem
            v-if="item.title != undefined"
            :to="index === 0 ? {} : {name: item.id, query: item.query}">
            <span>
              {{item.title}}
            </span>
          </BreadcrumbItem>
        </span>
      </Breadcrumb>
    </div>
  </div>
</template>
<script>
import {loadImg} from '@/utils'
import Iconfont from '@/components/iconfont'
// 三员编码系统管理员
const admiunWhiteCode = ['yemianpeizhi']
export default {
  data () {
    return {
      show: false,
      animateUp: false,
      intNum: null,
      events: [],
      routeName: '',
      separator: `<i class="icon iconfont iv-fs-16 iv-fc-85">/</i>`
    }
  },
  
  computed: {
    currentRouteName () {
      return this.$route.name
    },
    crumbsList () {
      return this.$store.state.crumbsList
    }
  },
  components: {
    Iconfont
  },
  created () {
    this.loadImg = loadImg
    //this.events = this.headerTips
    // this.listTips()
  },
  mounted () {
    this.ScrollUp()
  },
  destroyed () {
    clearInterval(this.intNum)
  },
  methods: {
    onClick () {
      this.$methods('settingInfo', 'open', 'Tips与文本管理')
    },
    // 鼠标移上去停止
    Stop () {
      clearInterval(this.intNum)
    },
    // 鼠标离开继续滚动
    Up () {
      this.ScrollUp()
    },
    ScrollUp () {
      let that = this
      this.intNum = setInterval(() => {
        this.animateUp = true// 向上滚动的时候需要添加css3过渡动画
        setTimeout(() => {
          that.events.push(that.events[0])// 将数组的第一个元素添加到数组的
          that.events.shift() // 删除数组的第一个元素
          that.animateUp = false
        }, 500)
      }, 10000)
    },
    listTips () {
      this.routeName = this.$route.name
      this.$ajax({
        url: 'module/tipsinfo/listTips',
        data: {
          'pageCode': this.routeName
        }
      }).then(({data}) => {
        this.events = []
        data.data.forEach(element => {
          if (element.activeState == 1) {
            this.events.push(element)
          }
        })
      })
    }
  },
  watch: {
    headerTips (val) {
      this.events = Object.assign([], val)
    },
    '$store.state.roleCode': {
      handler (val) {
        val.map(item => {
          if (admiunWhiteCode.includes(item)) {
            this.show = true
          }
        })
      }
    },
    $route () {
      this.listTips()
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/blue/index.scss';
  .iv-custom-bg-color {
    background: #fff;
  }
  .iv-breadcrumb-container {
    // background: #fff;
    position: relative;
    .iv-breadcrumb-container-bg {
      position: absolute;
      top: 10%;
      left: 50%;
      margin-left: -130px;
    }
    /deep/ .ivu-breadcrumb {
      display: inline-block;
      & > span:last-child {
        font-weight: 700;
      }
    }
  }
  .iv-tips-wrapper {
    margin-right: 48px;
  }
  /deep/ .ivu-breadcrumb a {
    font-size: 16px !important;
    line-height: 24px !important;
    color: rgba(0, 0, 0, 0.45) !important;
    // @extend .iv-fs-16;
    // @extend .iv-fc-85;
  }
  /deep/ .ivu-breadcrumb-item-separator {
    margin: 0;
  }
  .animate-up {
    transition: all 0.5s ease-in-out;
    transform: translateY(-40px);
  }
  .iv-sub-title {
    height: 18px;
    vertical-align: bottom;
    display: inline-block;
    overflow: hidden;
  }
  .iv-details {
    color: #F5A623;
    border-bottom: 1px solid;
  }
  /deep/ .ivu-tooltip-inner {
    color: #000000 !important;
    background: #fff !important;
    border: 0.5px solid #F5A623 !important;
  }
  /deep/ .ivu-poptip-body {
    border: 0.5px solid #F5A623 !important;
  }
  /deep/ .ivu-poptip-arrow:after {
    border-bottom-color: #F5A623 !important;
  }
</style>
